// Module
var code = "<div class=\"header-page\"> <div class=\"back\"> <a ng-click=\"backPrevLocation($event)\"><i class=\"fas fa-long-arrow-alt-left\"></i></a> </div> <div class=\"center\"> <h1 translate>{{ 'app.public.store.fablab_store' }}</h1> </div> <div class=\"right\"> <cart-button/> </div> </div> <section class=\"m-lg\"> <store current-user=\"currentUser\" on-error=\"onError\" on-success=\"onSuccess\" ui-router=\"uiRouter\"/> </section> ";
// Exports
var _module_exports = code;;
var path = '/store/index.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;